import { AUTH_PREFIX_PATH } from "configs/AppConfig";
import { PATH_VARIABLE } from "constants/ApiConstant";

export const tabRefs = [];

const SESSION_HANDOFF_KEY = "extremeb2b:session-handoff";
const LOGIN_TAB_RETIRED_KEY = "extremeb2b:login-tab-retired";

const getLoginUrl = () => `${PATH_VARIABLE}${AUTH_PREFIX_PATH}/login`;

export const isLoginTabRetired = () => {
  try {
    return sessionStorage.getItem(LOGIN_TAB_RETIRED_KEY) === "1";
  } catch (error) {
    return false;
  }
};

export const settlePreviousTabAfterLogin = () => {
  window.setTimeout(() => {
    try {
      sessionStorage.setItem(LOGIN_TAB_RETIRED_KEY, "1");
    } catch (error) {
      // ignore sessionStorage errors
    }
    try {
      window.close();
    } catch (error) {
      // window.close is only allowed for script-opened windows
    }
    if (!window.closed) {
      window.location.replace(getLoginUrl());
    }
  }, 0);
};

/** Open app route in a new tab and retire the current (login) tab. */
export const openAppInNewTab = (url) => {
  const openedTab = window.open(url, "_blank");
  if (openedTab) {
    tabRefs.push(openedTab);
  }
  try {
    localStorage.setItem(SESSION_HANDOFF_KEY, String(Date.now()));
  } catch (error) {
    // ignore quota errors
  }
  settlePreviousTabAfterLogin();
  return openedTab;
};

let sessionHandoffListenerInstalled = false;

/** Other tabs redirect to login when session continues in a newly opened tab. */
export const installSessionHandoffListener = () => {
  if (typeof window === "undefined") {
    return () => {};
  }

  if (sessionHandoffListenerInstalled) {
    return () => {};
  }
  sessionHandoffListenerInstalled = true;

  const handler = (event) => {
    if (event.key !== SESSION_HANDOFF_KEY || !event.newValue) {
      return;
    }

    const path = window.location.pathname;
    if (path.includes("/auth/")) {
      settlePreviousTabAfterLogin();
    }
  };

  window.addEventListener("storage", handler);
  return () => {
    window.removeEventListener("storage", handler);
    sessionHandoffListenerInstalled = false;
  };
};
